<template>
  
    <modal :show.sync="activarModal" >
      <b-card no-body class="overflow-hidden">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum quos illo optio eaque voluptatum accusantium earum veniam et similique, facere ut ipsam quibusdam dolorem sequi accusamus possimus, esse harum. Voluptate?

        Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid tenetur, eum nisi facilis ea blanditiis deleniti ullam ratione doloribus ipsa cumque autem non explicabo dolorum quidem est. Maiores, dolor vero.

        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eos, beatae? Cupiditate magni porro, aperiam odit ab, placeat alias aspernatur minus animi beatae veniam eius sequi provident ipsum iure dignissimos ipsam?

      </b-card>
      <b-button @click="submit()">Aceptar</b-button>
    </modal>

</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  name: "ModalDeclaracionDoctrinal",
  components: {
    Modal,
  },
  props: ["activarModal"],
  data: function() {
    return {

    };
  },
  methods: {
    submit() {
      console.log('hola');
      this.$emit('aceptarDeclaracion');
    }
  },
  computed: {
    
  }
};
</script>
